import styles from "./Popup.module.css";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { TextField, Button, MenuItem, Select, InputLabel, FormControl, DialogTitle, DialogContent, IconButton } from "@mui/material";
import { NumericFormat } from "react-number-format";
import { authData } from "../GetAuth";
import { Close } from "@mui/icons-material";
import { Check, X } from "react-feather";

export default function BookingPaymentPopup({ modalClose, paymentItem, selectBooking, setLoading }) {
  const auth = authData();
  const API_TOKEN = auth?.api_token;

  const { register, control, handleSubmit, formState: { errors }, clearErrors, setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      note: "",
    },
  });

  const onSubmitLocal = (data) => {
    modalClose();
    setLoading(true);
    data = { ...data, payment_status: 1 };

    axios.post(process.env.REACT_APP_API_URL + "v1/add-payment/" + selectBooking.id, data, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        paymentItem(response.data);
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  };

  return (<>
    <DialogTitle id="alert-dialog-title" className={`${styles.PopupTitleBar}`}>
      Payment
      <IconButton onClick={(e) => modalClose(false)} className={`${styles.PopupCloseBU}`} aria-label="Close"><Close /></IconButton>
    </DialogTitle>
    <DialogContent className={`${styles.PopupContent}`}>
      <form onSubmit={handleSubmit(onSubmitLocal)}>
        <div className={`${styles.FormMainRow}`}>
          <div className={`${styles.FormGroupHalf}`}>
            <FormControl fullWidth>
              <InputLabel>Payment Type*</InputLabel>
              <Controller
                control={control}
                {...register("payment_type", { required: "Please select payment type" })}
                render={({ field }) => (<Select
                  label="Payment Type*"
                  {...field}
                  onChange={(e) => {
                    field.onChange(e);
                    if (e.target.value === 'part') {
                      setValue('amount', '');
                    } else {
                      let dueamnt = parseFloat(selectBooking?.total) - parseFloat(selectBooking?.paid_amount);
                      setValue('amount', dueamnt);
                      clearErrors();
                    }
                  }}
                >
                  <MenuItem value="full">Due Amount</MenuItem>
                  <MenuItem value="part">Part Payment</MenuItem>
                </Select>)}
              />
            </FormControl>
            {errors.payment_type && <span className={`${styles.ErrorM}`}>{errors.payment_type.message}</span>}
          </div>
          <div className={`${styles.FormGroupHalf}`}>
            <FormControl fullWidth>
              <Controller
                control={control}
                {...register('amount', { required: 'Please enter amount' })}
                render={({ field }) => (<NumericFormat
                  {...field}
                  label="Amount*"
                  variant="outlined"
                  customInput={TextField}
                  allowLeadingZeros={false}
                  allowNegative={false}
                  decimalScale={2}
                  fixedDecimalScale
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                />)}
              />
            </FormControl>
            {errors.amount && <span className={`${styles.ErrorM}`}>{errors.amount.message}</span>}
          </div>
          <div className={`${styles.FormGroupHalf}`}>
            <FormControl fullWidth>
              <InputLabel>Payment Method*</InputLabel>
              <Controller
                control={control}
                {...register("payment_method", { required: "Please select payment method" })}
                render={({ field }) => (<Select
                  label="Payment Method*"
                  {...field}
                >
                  <MenuItem value="Cash">Cash</MenuItem>
                  <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                  <MenuItem value="Card Payment">Card Payment</MenuItem>
                </Select>)}
              />
            </FormControl>
            {errors.payment_method && <span className={`${styles.ErrorM}`}>{errors.payment_method.message}</span>}
          </div>
          <div className={`${styles.FormGroupFull}`}>
            <FormControl fullWidth>
              <Controller
                control={control}
                {...register("note", { required: 'Please enter note' })}
                render={({ field }) => (
                  <TextField {...field} label="Payment Note*" variant="outlined" multiline rows={4} />
                )}
              />
            </FormControl>
            {errors.note && <span className={`${styles.ErrorM}`}>{errors.note.message}</span>}
          </div>
        </div>

        <div className={`${styles.ButtonAction}`}>
          <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={(e) => modalClose()}>Cancel</Button>
          <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} type="submit">Payment</Button>
        </div>
      </form>
    </DialogContent>
  </>);
}